import { el } from '../../core/dom.js';
import { api } from '../../core/api.js';
import { navigate } from '../../core/router.js';
import {
  loginOauthBanner,
  loginPayload,
  oauthStartUrl,
  parseAuthSearch,
  postLoginPath,
} from './model.js';
import { authShell, errorBox, setError, socialRow } from './layout.js';

async function rememberSession(data) {
  localStorage.setItem('accessToken', data.accessToken);
  if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
  if (data.user) localStorage.setItem('user', JSON.stringify(data.user));
  try { localStorage.removeItem('selectedProductId'); } catch { /* ignore */ }
}

async function goAfterLogin() {
  const products = await api('/products');
  const list = products && Array.isArray(products.products) ? products.products : [];
  window.location.href = postLoginPath({ hasProducts: list.length > 0 });
}

/**
 * @param {{ search?: string }} [opts]
 */
export function renderLogin(opts) {
  const query = parseAuthSearch(opts && opts.search);
  const banner = loginOauthBanner(query.oauth);
  const err = errorBox('');
  if (banner) {
    err.hidden = false;
    err.replaceChildren(
      document.createTextNode(banner.before),
      banner.link
        ? el('a', {
          href: '/app/signup',
          class: 'auth-lnk',
          onClick(event) {
            event.preventDefault();
            navigate('/app/signup');
          },
        }, banner.link)
        : null,
      banner.after ? document.createTextNode(banner.after) : null,
    );
  }

  const email = el('input', {
    class: 'auth-fld',
    type: 'email',
    name: 'email',
    autocomplete: 'email',
    placeholder: 'you@company.com',
    required: true,
  });
  const password = el('input', {
    class: 'auth-fld',
    type: 'password',
    name: 'password',
    autocomplete: 'current-password',
    placeholder: 'Enter your password',
    required: true,
  });

  const form = el('form', {
    class: 'auth-form',
    onSubmit: async (event) => {
      event.preventDefault();
      const body = loginPayload({ email: email.value, password: password.value });
      setError(err, '');
      const data = await api('/auth/login', { method: 'POST', body });
      if (data && data.error) {
        setError(err, data.error);
        return;
      }
      if (!data || !data.accessToken) {
        setError(err, 'Connection failed. Is the server running?');
        return;
      }
      await rememberSession(data);
      await goAfterLogin();
    },
  },
  el('label', { class: 'auth-field' },
    el('span', { class: 'lbl auth-field-lbl' }, 'Work email'),
    email),
  el('label', { class: 'auth-field' },
    el('span', { class: 'lbl auth-field-lbl' }, 'Password'),
    password),
  el('div', { class: 'auth-cta' },
    el('button', { type: 'submit', class: 'auth-go' }, 'Sign in ', el('span', { class: 'auth-arw' }, '→')),
    el('span', { class: 'auth-alt' },
      'New here? ',
      el('a', {
        href: '/app/signup',
        class: 'auth-lnk',
        onClick(event) {
          event.preventDefault();
          navigate('/app/signup');
        },
      }, 'Create a workspace'))));

  return authShell({
    kicker: '✦ Sign in',
    title: 'Welcome ',
    titleEm: 'back.',
    lead: 'Sign in, pick a product, pick up where you left off.',
    error: err,
    children: [
      socialRow('login', (provider) => {
        window.location.href = oauthStartUrl(provider, 'login');
      }),
      el('div', { class: 'auth-or lbl' }, 'or use email'),
      form,
    ],
    foot: el('p', { class: 'auth-foot' },
      'Social login is identity only. Connecting GitHub as a ',
      el('em', null, 'data source'),
      ' happens later, per product, through the connector form.'),
  });
}
